export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '11f57dc2-6e7f-49a9-aba0-4caae48b10fd',
      authority: 'https://login.microsoftonline.com/e0aadfc7-8ad3-4b7b-b063-42bfea6a739d',
    },
    uri: 'api://11f57dc2-6e7f-49a9-aba0-4caae48b10fd/.default',
  },
  apiConfig: {
    scopes: ['api://SecretManagerScope/LogIn'],
    uri: 'https://api.tst.sm.assetworks.com/secretmgr-app',
    ssoUri: 'https://api.tst.sm.assetworks.com/secretmgr-app-sso',
  },
  'Ocp-Apim-Subscription-Key': 'ec71d4ac65134a31997eb604952556f5',
  singleSignOnConfig: {
    loginCallbackUrl: 'https://app.tst.sm.assetworks.com/login/',
    logoutCallbackUrl: 'https://app.tst.sm.assetworks.com/logout/',
    cookieDomain: '.tst.sm.assetworks.com',
  },
};
